module.exports = __webpack_public_path__ + "img/border-b.aed507e.png";